import { useSelector } from "react-redux";
import { User } from "configcat-js";
import { useFeatureFlag as useFeatureFlagConfigCat } from "configcat-react";

import { selectCurrentAccount, selectUserId, selectUsername } from "fond/api";

export const useFeatureFlag = (flagName: string, defaultValue: boolean = false): { value: boolean; loading: boolean } => {
  const userId = useSelector(selectUserId);
  const userEmail = useSelector(selectUsername);
  const currentAccount = useSelector(selectCurrentAccount);

  const user = new User(
    userId || "default",
    userEmail,
    undefined, // country
    { AccountId: currentAccount?.ID || "default" } // custom attributes
  );
  return useFeatureFlagConfigCat<boolean>(flagName, defaultValue, user);
};
